export type Category = "restaurant" | "shop" | "office" | "carpark" | "venue_rental" | "other";
export type Status = "active" | "in_progress" | "vacant";
export type Zone = "green" | "lightBlue" | "blue";
export type ColorMode = "category" | "custom";

export interface UnitSection {
  title: string;
  text: string;
}

export interface ApiUnit {
  id: string;
  floorLevel: string;
  floorOrder: number;
  category: Category;
  status: Status;
  tenantName: string | null;
  description: string;
  photos: string[];
  logo: string | null;
  area: string | null;
  hours: string | null;
  phones: string[];
  emails: string[];
  websites: string[];
  features: string[];
  sections: UnitSection[] | null;
}

export interface ApiLocation {
  id: string;
  name: string;
  mapRefCode: string | null;
  zone: Zone | null;
  kind: string;
  svgParcelId: string | null;
  svgParcelIds?: string[];
  grouped?: boolean;
  colorMode: ColorMode;
  customFill: string | null;
  markedOnMap: boolean;
  units: ApiUnit[];
}

export interface CategoryStyle {
  category: Category;
  fill: string;
  ink: string;
}

export interface MapData {
  categoryStyles: CategoryStyle[];
  locations: ApiLocation[];
}

export const CATEGORY_LABEL: Record<Category, string> = {
  restaurant: "Restaurants & Bars",
  shop: "Shops",
  office: "Offices",
  carpark: "Car Park",
  venue_rental: "Venue Rental",
  other: "Other",
};

export const STATUS_LABEL: Record<Status, string> = {
  active: "Active",
  in_progress: "In Progress",
  vacant: "Vacant",
};
